module.exports = __webpack_public_path__ + "webStatic/img/offiaccount.a0052307.png";